export type EmployeeAccountCardsType = {
    id: string
    image: {
        url: string
        alt: string
    },
    title: string
}
export const employeeAccountCards: EmployeeAccountCardsType[] = [{
    id: '1',
    image: {
        url: '/png/dev_plan.png',
        alt: 'Индивидуальный план развития',
    },
    title: 'Индивидуальный план развития'
}, {
    id: '2',
    image: {
        url: '/png/cards.png',
        alt: 'Карточки всех скилов',
    },
    title: 'Карточки всех скилов'
}, {
    id: '3',
    image: {
        url: '/png/canban.png',
        alt: 'Канбан-доска обучения',
    },
    title: 'Канбан-доска обучения'
}, {
    id: '4',
    image: {
        url: '/png/progress.png',
        alt: 'Прогресс развития',
    },
    title: 'Прогресс развития'
}, {
    id: '5',
    image: {
        url: '/png/calendar.png',
        alt: 'Календарь встреч с наставником',
    },
    title: 'Календарь встреч с наставником'
},
]